import fetch from "@lib/fetch";
import { API } from "../../config";

export const getInventoryByUserId = (token, id) => {
    return fetch(`${API}/v1/admin/inventories/users/${id}`,{
        mode: 'cors',
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json()
        })
        .catch(error => {
            console.log(error);
        })
};
